import {
    Component,
    Input,
    HostBinding,
    Output,
    EventEmitter
} from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import {
    ShowDlgTransferService
} from '../../shared-dialogs.module/show-dlg-transfer.service';
import {
    ITEM_SHOP_URL,
    UNLIMITED_ACCESS_STORE_URL,
} from '../store-urls';

@Component({
    selector: 'app-store-access-key',
    templateUrl: './store-access-key.component.pug',
    styleUrls: ['./store-access-key.component.less']
})
export class StoreAccessKeyComponent {
    @HostBinding('class.--ui') _ui = true;

    itemShopUrl = ITEM_SHOP_URL;
    unlimitedAccessStoreUrl = UNLIMITED_ACCESS_STORE_URL;

    @HostBinding('attr.disabled') disabled;

    @Input() steam: any;
    @Input() unlimitedAccessKeys: any;

    _amountSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    amount$: Observable<number> = this._amountSbj.asObservable();
    @Input() set amount(amount: number) {
        this._amountSbj.next(amount >= 0 ? amount : 0);
    }

    @Output() close: EventEmitter<any> = new EventEmitter();
    @Output() transfer: EventEmitter<any> = new EventEmitter();

    constructor(
        private _dlgTransferSrv: ShowDlgTransferService
    ) {
    }

    onClose() {
        this.close.emit();
    }

    async onTransfer() {
        this._disable();

        let count;
        try {
            count = await this._dlgTransferSrv.show({
                limit: this._amountSbj.getValue(),
                title: 'How many <span class="--color-text-keys">Access keys</span> do you want to transfer?',
                button: 'Transfer&nbsp;<app-icon-access-key></app-icon-access-key>&nbsp;to Steam'
            });
        } catch (err) {
            console.debug('StoreAccessKeyComponent::onTransfer', err);

            this._enable();
            return;
        }

        this.transfer.emit(count);
    }

    _disable() {
        this.disabled = true;
    }

    _enable() {
        this.disabled = false;
    }
}
